import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class ConfiguratorCertificateApiService {

  private readonly configurationCertificateUrl = 'configuration/keystore';

  private readonly generateKeystoreUrl: string = `${this.configurationCertificateUrl}/generate`;
  private readonly generateAndReplaceKeystoreUrl: string = `${this.configurationCertificateUrl}/replace`;
  private readonly generateKeystoreAndCsrUrl: string = `${this.configurationCertificateUrl}/csr`;

  private readonly uploadKeystoreUrl: string = `${this.configurationCertificateUrl}/upload`;
  private readonly uploadKeystoreUrlAndCsrUrl: string = `${this.configurationCertificateUrl}/csr/upload`;

  constructor(private http: HttpClient) {}

  public getCurrentCertificate(): Observable<any> {
    return this.http.get(this.configurationCertificateUrl);
  }

  public generateKeystore(certificate): Observable<any> {
    return this.http.post(this.generateKeystoreUrl, certificate, {responseType: 'blob'});
  }

  public generateAndReplaceKeystore(certificate): Observable<any> {
    return this.http.post(this.generateAndReplaceKeystoreUrl, certificate);
  }

  public generatePrivateKeyAndCsr(certificate): Observable<any> {
    return this.http.post(this.generateKeystoreAndCsrUrl, certificate, {responseType: 'blob'});
  }

  public uploadConfigurationKeystore(certificate): Observable<any> {
    return this.uploadKeystore(this.uploadKeystoreUrl, certificate);
  }

  public uploadConfigurationKeystoreAndCsr(certificate): Observable<any> {
    return this.uploadKeystoreAndCsr(this.uploadKeystoreUrlAndCsrUrl, certificate);
  }

  private uploadKeystore(url, certificate): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('keystore', certificate.keyStoreFile);

    if (!_.isNil(certificate.password)) {
      formData.append('storepass', certificate.password);
    }

    return this.http.post(url, formData);
  }

  private uploadKeystoreAndCsr(url, certificate): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('keystore', certificate.keyStoreFile);
    formData.append('response', certificate.csrfile);

    if (!_.isNil(certificate.password)) {
      formData.append('storepass', certificate.password);
    }

    if (!_.isNil(certificate.alias)) {
      formData.append('alias', certificate.alias);
    }

    return this.http.post(url, formData);
  }
}
